<template>
  <div class="wrapper pagination pagination-absolute">
    <Menu />
    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0 mb-2">
            <carousel
              :perPage="1"
              paginationActiveColor="#fff"
              paginationColor="rgba(255,255,255,.43)"
            >
              <slide v-for="item in news" :key="item.slug">
                <div
                  class="slider-box position-relative"
                  @click="getNews(item.link.replace('/haber/', ''))"
                >
                  <img :src="$store.state.baseImageURL + item.image" class="w-100 slider-image" />
                  <h1 class="fs-32 fc-5 slider-title position-absolute z-9">{{item.title}}</h1>
                </div>
              </slide>
            </carousel>
          </div>
          <div class="w-100 pagination pagination-relative col-12">
            <carousel :perPage="1" ref="matchCarousel">
              <slide v-for="item in matches" :key="item.id">
                <div class="w-100">
                  <MatchVS :data="item"></MatchVS>
                </div>
              </slide>
            </carousel>
          </div>

          <div class="col-12 text-center pt-3 pb-3">
            <a
              href="javascript:;"
              v-if="!$store.getters.isLogged"
              @click="$router.push({name: 'Login'})"
            >
              <img :src="$store.state.ads.nofanclub.srcUrl" alt class="w-100" />
            </a>

            <div v-if="$store.getters.isLogged">
              <iframe
                :src="$store.state.ads.home.srcUrl"
                style="width: 100%;"
                :style="'height: calc(' + (parseInt($store.state.ads.home.height.replace('%', ''))) + 'vw)'"
              ></iframe>
            </div>
          </div>

          <CampaignCarousel :data="campaigns"></CampaignCarousel>

          <Leader :data="stats" />


        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import MatchVS from "@/components/MatchVS";
import Leader from "@/components/Leader";
import moment from "moment";
import axios from "axios";


export default {
  name: "HomeDefault",
  props: ["title"],
  components: {
    Footer,
    Menu,
    MatchVS,
    Leader
  },
  data() {
    return {
      currentDate: Date.now(),
      moment,
      news: [],
      campaigns: [],
      matches: [],
      stats: [],
      data: {
        dateTime: new Date('30 May 2021 21:30 UTC+3')
      }
    };
  },
  methods: {
    getNews(slug) {
      this.$store.state.loading = true;
      axios.get("/haber/detay?slug=" + slug).then(res => {
        this.$store.state.loading = false;
        this.$router.push({
          name: "NewsDetail",
          params: { data: res.data.data, slug }
        });
      });
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.matchCarousel.navigateTo = 1;
    }, 1000);
  },
  beforeMount() {
    /** setInterval(() => {
      this.currentDate = Date.now();
      this.dateTime = new Date('30 May 2021 21:30 UTC+3');
      var diff = this.dateTime - this.currentDate;
      var duration = moment.duration(diff, "milliseconds");
      this.duration = moment.duration(duration - 1000, "milliseconds");
    }, 1000); **/

    this.$store.state.loading = true;

    axios.post("haber").then(res => {
      this.$store.state.loading = false;

      this.news = res.data.headlines;
    });

    axios.post("kampanya/liste").then(res => {
      var data = [];
      res.data.data.map((item, index) => {
        if (index <= 4) {
          data.push(item);
        }
      });
      this.campaigns = data;
    });

    axios.post("mac-listesi/homepage").then(res => {
      this.matches = res.data.data;
    });

    axios.post("istatistik/home").then(res => {
      var data = [];

      data.push({
        title: "Sayı",
        ...res.data.hallOfFame.scorer[0]
      });

      data.push({
        title: "Asist",
        ...res.data.hallOfFame.assister[0]
      });

      data.push({
        title: "Ribaund",
        ...res.data.hallOfFame.rebounder[0]
      });

      data.push({
        title: "Blok",
        ...res.data.hallOfFame.block[0]
      });

      data.push({
        title: "Top Çalma",
        ...res.data.hallOfFame.steals[0]
      });

      this.stats = data;
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/HomeDefault.vue